export const endPoints = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  api: {
    geocomplyLience: "geocomplyLience",
    geocomplyLience1: "geocomplyLience1",
    LOGIN_ENDPOINT: "users/login",
    SIGNUP: "users/signup", //account-management1/users/signup
    GET_BY_USERID: "users/userid", // 12  Append userid
    GET_BY_USERNAME: "users/username/", // userrname
    UPDATE_PERSONAL: "users/personal",
    UPDATE_PROFILE_IMAGE: "upload/profileimage",
    EMAIL_SUPPORT: "email/support",
    VERIFICATION_ENDPOINT: "users/validate",
    STATES: "states",
    UPDATE_EMAIL: "users/email",
    FORGOT_PASSWORD: "users/passwordlost/",
    GET_SPORTS_DATA: "api/sports/id", //sportsid 6046
    CHANGE_PASS: "users/password",
    GET_QUESTIONS: "questions",
    GET_DOCUMENTS: "documentTypes",
    transactions: "alltransactions",
    activations: "activations",
    ssnVerification: "api/ssn/verification",
    Reset_password: "reset/password",
    resendMail: "user/resend",
    GetUserLimit: "user/limit/",
    SetUserLimit: "user/limit",
    brochures: "brochures",
    brochureDetails: "brochureDetails",
    order: "transactions/order",
    ordersHistory: "orders",
    apiurl: "user/kyc/token",
    banking_withdraw: "banking/withdrawals",
    kyc_verify: "user/kyc/verify/",
    KYC_SAVE: "api/kyc/save",
    KYC_UPLOAD: "upload/kycdoc",
    promo: "/promo/apply",
    GET_BANNER: "activepromotions",
    GOOGLE_LOGIN: "user/loginwithgoogle",
    USER_PROFILE: "user/profile",
    USER_TRACE: "user/logintrace",
    CHECK_USER: "/banner/click",
    USER_AVAILABILTY: "users/username",
    EMAIL_AVAIALBILTY: "users/email",
    USER_SIGNUP: "users/fullsignup",
    RADAR_API: "api/radar/search",
    EMAIL_POPUP: "user/emailpopup",
    SKRILL_PAYMENT: "skrill/payment/addpayment",
    SKRILL_WITHDRAW: "api/skrillcustomer/withdrawfunds",
    userRGLimit: "user/rglimit",
    USER_COOLOFF: "/user/cooloff",
    USER_EXCLUDE: "/user/exclude",
    GET_PROMO_LIST: "api/casino/promos",
    PAGE_VISITED: "event/pagevisited",
    LEAGUE_VISITED: "event/leagueloaded",
    SKRILL_WITHDRAW: "skrill/payment/withdrawfunds",
    COREPAY_WITHDRAW: "corepay/payment/withdrawfunds",
    GET_ALL_COUPONS: "api/coupon/active",
    BET_TRAKING: "user/bettrack",
    OFFER_USER: "offer/user",
    REFERAL_TABLE: "getpromoByUser",
    GET_SPIN_VALUES: "v2/user/spin",
    GET_SPIN_PRIZE: "user/dailySpinClaim",
  },
  mode: "Development",
};

export const PaymentEndpoints = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL_PAYMENT,
  api: {
    ACTIVATE: "api/payment/enroll",
    WALLET: "api/payment/wallet",
    INFORMATION: "api/payment/information/",
    deposit_WithDraw: "api/payment/transfers",
    fabiwallet: "api/payment/information",
    SKRILL_WALLET: "api/skrillcustomer/payment",
    FAILED_DEPOSIT: "api/skrillcustomer/failedpayment",
    COREPAY_DEPOSIT: "api/corepay/payment",
    UPDATE_COREPAY: "api/corepay/customerupdate",
    ACH_DEPOSIT: "api/corepay/deposit",
  },
};

export const sportEndPoint = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL_SPORT,
  api: {
    leagueByIdUrl: "api/league/",
    leagueList: "api/leagues",
    sports: "api/sports/",
    sportsById: "api/sports/",
    wagers: "api/league/wagers/",
    LOG_BET: "api/bets/process",
    Out_Right: "api/outrightmarkets/",
    Default_Bet_Config: "api/config",
    all_bets: "api/bets/info",
    Odds_Refresh: "api/sports/getOdds",
    futureLeague: "api/league/future/",
    live_now: "api/league/live",
    playerData: "api/sportplayers/",
    playersportsData: "api/playerevent/sport/",
    playerleagueData: "api/playerevent/league/",
    MultiplayersportsData: "api/event/sport/",
    MultiplayerleagueData: "api/event/league/",
    mybets: "api/fantasy/info",
    fantasy: "api/fantasy/bet",
    Image: "api",
    maintenance: "api/maintenance",
    PENDING_BETS: "api/fantasy/pending",
    COMPLETED_BETS: "api/fantasy/complete",
    BET_PAYOUT: "api/fantasy/betpayout",
  },
  mode: "Development",
};

export const Image_Url =
  "https://elasticbeanstalk-us-east-1-715244717776.s3.amazonaws.com/team/";
export const SportImage_Url =
  "https://elasticbeanstalk-us-east-1-715244717776.s3.amazonaws.com/sports/";
export const LeagueImage_Url =
  "https://elasticbeanstalk-us-east-1-715244717776.s3.amazonaws.com/leagues/";
export const API_URL = "";
export const Voucher_Url =
  "https://elasticbeanstalk-us-east-1-715244717776.s3.amazonaws.com";

export const PlayerCardImageUrl = import.meta.env.VITE_API_BASE_URL_SPORT || "https://sportsfeed.bettdraft.com:5000/api";
// "https://sportsfeed.bettdraft.com:5000/api";

export const appVersion = {
  version: "2.4.0",
};

export default {};

